import { combineReducers } from 'redux';
import dinings from './dinings';
import bookingSearch from './bookingSearch';
import sessionCreation from './sessionCreation';
import changeAddon from './changeAddon';
import availableEntertainments from './availableEntertainments';
import bookedEvents from './bookedEvents';
import bookedEntertainments from './bookedEntertainments';
import config from './config';
import swimming from './swimming';
import arrivalTime from './arrivalTime';
import dineAround from './dineAround';
import backstopDate from './backstopDate';

export default combineReducers({
  dinings,
  bookingSearch,
  sessionCreation,
  changeAddon,
  availableEntertainments,
  bookedEvents,
  bookedEntertainments,
  config,
  swimming,
  arrivalTime,
  dineAround,
  backstopDate,
});
